import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ElderRouterService, RestClientPaged } from '@elderbyte/ngx-starter'
import { environment } from '../../../environments/environment'
import { Job } from './job'
import { Observable } from 'rxjs'
import { JobCommand } from './job-command'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class JobService extends RestClientPaged<Job, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(
    http: HttpClient,
    private router: Router,
    private elderRouter: ElderRouterService
  ) {
    super(environment.apiPath + '/jobs', http, {})
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public runCommand(jobId: string, command: JobCommand): Observable<Job> {
    return this.http.post<Job>(super.getEntityUrl(jobId) + '/command', command)
  }

  public openJobInNewTab(jobId: string): void {
    if (jobId) {
      this.elderRouter.openUrl(this.router.createUrlTree(['app/jobs/', jobId]))
    }
  }
}
